import { Svg } from '../../../LegacyApp/client/components/svg/Svg';

const Icon = () => {
	return Svg({
		content: (
			<g>
				<circle cx="250" cy="250" r="250" fill="#002D74" />
				<g>
					<path
						d="M250.14,55.59l-.28.16v-.16l-168.08,97.2v194.41l168.08,97.2h.28l168.08-97.2v-194.41L250.14,55.59ZM368.35,318.35l-118.49,68.35-118.21-68.35v-136.7l118.49-68.35,118.21,68.35v136.7Z"
						fill="#fff"
					/>
					<polygon
						points="249.86 197.06 295.8 223.67 328.58 204.62 250.14 159.24 171.42 204.62 171.42 295.38 250.14 340.76 328.58 295.38 296.08 276.61 250.14 303.22 204.2 276.61 204.2 223.67 249.86 197.06"
						fill="#fff"
					/>
				</g>
			</g>
		),
		width: 500,
		height: 500,
	});
};

export default Icon;
